import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {TrackAdvancedLazy} from "@containers/map/containers/trackAdvanced/TrackAdvanced.lazy";


const TrackAdvancedPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <TrackAdvancedLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default TrackAdvancedPage;